<template>
	<!-- BEGIN login -->
	<div class="login login-with-news-feed">
		<!-- BEGIN news-feed -->
		<div class="news-feed">
			<div class="news-image" style="background-image: url(/assets/img/login-bg/7-min.png)"></div>
			<div class="news-caption">
				<h4 class="caption-title" v-html="siteName"></h4>
				<p>
					Здесь вы можете получить живых подписчиков и лайки во всех соц. сетях, поднять посещаемость вашего
					сайта, раскрутить любой ваш проект или набрать
					рефералов на другие проекты. Только живой трафик, быстрое и
					качественное выполнение ваших заказов.
				</p>
			</div>
		</div>
		<!-- END news-feed -->
    

		<!-- BEGIN login-container -->
		<div class="login-container">
			<!-- BEGIN login-header -->
			<div class="login-header mb-15px">
				<div class="brand">
					<div class="d-flex align-items-center">
						<span v-html="siteName"></span>
					</div>
					<small>Биржа простых задач</small>
				</div>
				<div class="icon">
					<i class="fa fa-sign-in-alt"></i>
				</div>
			</div>
			<!-- END login-header -->

      <div class="mb-15px">
        <a href="https://t.me/fastsmm_ru_bot?start" target="_blank" class="btn btn-info d-block  h-45px w-100 btn-lg fs-14px" style="padding: 12px 16px;">
          <i class="fab fa-lg fa-fw fa-telegram"></i>
          <span> Войти через Telegram</span>
        </a>
      </div>

			<!-- BEGIN login-content -->
			<div class="login-content">
				<validation-observer ref="form">
					<form v-on:submit="checkForm" method="GET" class="fs-13px">

						<validation-provider #default="{ errors }" name="email" rules="required|min:4|max:64"
							vid="email">
							<div class="form-floating mb-15px">
								<input type="text" v-model="email" class="form-control h-45px fs-13px"
									placeholder="Email Address" id="emailAddress" />
								<label for="emailAddress" class="d-flex align-items-center fs-13px text-gray-600">Email
								</label>
								<small class="text-danger">{{ errors[0] }}</small>

							</div>
						</validation-provider>

						<validation-provider #default="{ errors }" name="password" rules="required|min:6|max:16"
							vid="password">
							<div class="form-floating mb-15px">
								<input type="password" v-model="password" class="form-control h-45px fs-13px"
									placeholder="Password" id="password" />

								<label for="password"
									class="d-flex align-items-center fs-13px text-gray-600">Пароль</label>
								<small class="text-danger">{{ errors[0] }}</small>

							</div>
						</validation-provider>
						<validation-provider #default="{ errors }" name="password_confirmation"
							rules="required|min:6|max:16|confirmed:password" vid="password_confirmation">
							<div class="form-floating mb-15px">
								<input type="password" v-model="password_confirmation"
									class="form-control h-45px fs-13px" placeholder="Password"
									id="password_confirmation" />

								<label for="password_confirmation"
									class="d-flex align-items-center fs-13px text-gray-600">Повторить
									пароль</label>
								<small class="text-danger">{{ errors[0] }}</small>

							</div>
						</validation-provider>
						<div class="form-check mb-5">
							<input class="form-check-input" type="checkbox" v-model="rules" id="rememberMe" />
							<label class="form-check-label" for="rememberMe">
								Я принимаю условия <a href="/#/rules">Публичной оферты</a>
							</label><br>
							<small class="text-danger" v-show="rules_error">Вам нужно ознакомиться с правилами</small>
							<small class="text-danger" v-show="multi_error">Регистрация более одного аккаунта запрещена.
								Работать и выводить деньги можно только с одного аккаунта. При регистрации 2 и более
								аккаунтов, все аккаунты будут заблокированы. Пожалуйста ознакомьтесь с нашими правилами.
							</small>
						</div>

						<div class="mb-15px">
							<button :disabled="loading || !email || !password || !password_confirmation || !rules"
								type="submit" class="btn btn-primary d-block h-45px w-100 btn-lg fs-14px">
								<i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
								Регистрация
							</button>
						</div>
						<div class="mb-40px pb-40px text-dark">
							Уже есть аккаунт? <router-link to="/login" class="text-primary">Войти
							</router-link>
						</div>
						<hr class="bg-gray-600 opacity-2" />
						<div class="text-gray-600 text-center text-gray-500-darker mb-0"
							v-html="`&copy; ` + siteName + ` All Right Reserved 2022`">
						</div>
					</form>
				</validation-observer>
			</div>
			<!-- END login-content -->
		</div>
		<!-- END login-container -->
	</div>
	<!-- END login -->
</template>

<script>
import AppOptions from '../config/AppOptions.vue'
import HTTP from "../http";
import { show_error } from "../message";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, max, min, confirmed } from 'vee-validate/dist/rules';
extend('required', required);
extend('email', email);
extend('min', min);
extend('max', max);
extend('confirmed', confirmed);

export default {
	components: {
		ValidationProvider,
		ValidationObserver
	},
	data() {
		return {
			email: "",
			password: "",
			password_confirmation: "",
			loading: false,
			errors: null,
			value: '',
			siteName: '',
			rules: false,
			rules_error: false,
			multi_error: false
		};
	},

	created() {
		AppOptions.appEmpty = true;
		this.siteName = process.env.VUE_APP_SITE_NAME

		if (this.$route.query.ref) {
			localStorage.setItem("ref", this.$route.query.ref);
		}

		if (this.$route.query.referer) {
			localStorage.setItem("referer", this.$route.query.referer);
		}
	},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	},
	methods: {
    loginByToken(token) {
      this.$insProgress.start();
      this.loading = true;
      HTTP()
        .post("/auth/login_by_token", {
          token: token,
          ref: localStorage.getItem("ref"),
          referer: localStorage.getItem("referer"),
        })
        .then((resp) => {
          console.log('resp=', resp)
          localStorage.setItem("access_token", resp.data.token.token);
          window.socket.emit("user.set_id", {user_id: resp.data.user.id});
          this.$router.push("/jobs/ALL");
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data);
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
		checkForm: function (e) {
			this.$refs.form.validate().then(success => {
				e.preventDefault();
				console.log('success', success)
				if (!success) {
					return;
				}

				if (!this.rules) {
					this.rules_error = true
					return
				}

				if (localStorage.getItem('welcome_msg') == 1
					|| !!localStorage.getItem('is_registered')) {
					this.multi_error = true;
					return;
				}

				this.$insProgress.start();
				this.loading = true;
				localStorage.setItem("email", this.email);
				localStorage.setItem("password", this.password);
				HTTP()
					.post("/auth/register", {
						email: this.email,
						password: this.password,
						password_confirmation: this.password_confirmation,
						ref: localStorage.getItem("ref"),
						referer: localStorage.getItem("referer"),
					})
					.then((resp) => {
						localStorage.setItem("user", JSON.stringify(resp.data.user));
						localStorage.setItem("access_token", resp.data.token.token);
						localStorage.is_registered = 1
						window.socket.emit('user.set_id', { user_id: resp.data.user.id })
						this.$router.push('/jobs/ALL')
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					})
					.finally(() => {
						this.loading = false;
						this.$insProgress.finish();
					});
			});

		},
	}
}
</script>